import { FlexBox, RoundImage, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { getInitials } from 'utils'

interface Props {
  image: string | null
  name: string
}

export const PersonImage = ({ image, name }: Props) => {
  const { colors, mediaQueries } = useTheme()
  const styles = css`
    width: 140px;
    height: 140px;
    ${mediaQueries.mobileL} {
      width: 200px;
      height: 200px;
    }
  `

  if (!image || !image.length) {
    return (
      <FlexBox
        className={css`
          ${styles};
          border-radius: 50%;
          overflow: hidden;
          background-color: ${colors.uiBlack};
        `}
        centerAll
      >
        <Text
          tag="h2"
          className="author-initials"
          type="header"
          sizing="XL"
          text={getInitials(name)}
          color={colors.uiWhite}
        />
      </FlexBox>
    )
  }

  return (
    <RoundImage
      className={css`
        ${styles};
        img {
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      `}
      src={image as string}
      alt={`${name} avatar`}
      size={600}
      diameter="200px"
    />
  )
}
